import { numberFormatter } from 'legacy/utils/formatters';

const LeafletCircleEditTooltip = ({ visible, radius, coords }) => {
  if (!visible) {
    return null;
  }
  // NOTE: Using 'leaflet-draw-tooltip' class rather than css-modules to keep
  //       to keep styles in sync between this and the default leaflet-draw tooltip
  return (
    <div
      style={{
        visibility: visible ? 'visible' : 'hidden',
        position: 'fixed',
        zIndex: 1000,
        ...coords
      }}
      className="leaflet-draw-tooltip"
    >
      Radius: {numberFormatter(radius * 0.00062137, { precision: 2 })} miles
    </div>
  );
};

export default LeafletCircleEditTooltip;
